import { Color, Grid, Heading, Text } from 'component-library';
import React from 'react';
import { FourPartTestItems } from './FourPartTestItems';

export const FourPartTestModalContent = () => {
  return (
    <Grid columns={12}>
      <Grid.Cell columns={4}>
        <div
          style={{
            backgroundColor: Color.blue._20,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/graphics/document-with-magnify-glass.svg`}
            alt={'document with magnify glass'}
          />
        </div>
      </Grid.Cell>

      <Grid.Cell columns={8} padding={[48, 24, 48, 24]}>
        <Heading text={'Four-part Test'} size={24} variant={'medium'} />
        <Text
          text={
            "For your project to qualify as a business component under R&D tax credit regulations, it must meet the IRS's four-part test requirements:"
          }
          paddingBottom={16}
        />
        <FourPartTestItems />
        {/*<Link*/}
        {/*  size={13}*/}
        {/*  external*/}
        {/*  text={'More details about the four-part test'}*/}
        {/*  href={'https://mainstreet.com'}*/}
        {/*/>*/}
      </Grid.Cell>
    </Grid>
  );
};
